import React from 'react';

export default function Box() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0001 30.7218C24.1309 30.7218 30.7223 24.1304 30.7223 15.9996C30.7223 7.86871 24.1309 1.27734 16.0001 1.27734C7.86919 1.27734 1.27783 7.86871 1.27783 15.9996C1.27783 24.1304 7.86919 30.7218 16.0001 30.7218Z"
        fill="white"
        stroke="black"
        strokeMiterlimit="10"
      />
      <path
        d="M16 8.09961L16.2014 7.64195C16.0731 7.5855 15.9269 7.5855 15.7986 7.64195L16 8.09961ZM8.5 11.3996L8.29863 10.942C8.11715 11.0218 8 11.2013 8 11.3996H8.5ZM8.5 20.5996H8C8 20.7999 8.11954 20.9809 8.30378 21.0595L8.5 20.5996ZM16 23.7996L15.8038 24.2595C15.9291 24.313 16.0709 24.313 16.1962 24.2595L16 23.7996ZM23.5 20.5996L23.6962 21.0595C23.8805 20.9809 24 20.7999 24 20.5996H23.5ZM23.5 11.3996H24C24 11.2013 23.8828 11.0218 23.7014 10.942L23.5 11.3996ZM15.8 14.4996L15.5946 14.9554L15.7986 15.0474L16.0031 14.9565L15.8 14.4996ZM15.7986 7.64195L8.29863 10.942L8.70137 11.8573L16.2014 8.55727L15.7986 7.64195ZM8 11.3996V20.5996H9V11.3996H8ZM8.30378 21.0595L15.8038 24.2595L16.1962 23.3397L8.69622 20.1397L8.30378 21.0595ZM16.1962 24.2595L23.6962 21.0595L23.3038 20.1397L15.8038 23.3397L16.1962 24.2595ZM24 20.5996V11.3996H23V20.5996H24ZM23.7014 10.942L16.2014 7.64195L15.7986 8.55727L23.2986 11.8573L23.7014 10.942ZM8.49455 11.7554L15.5946 14.9554L16.0055 14.0438L8.90545 10.8438L8.49455 11.7554ZM16.0031 14.9565L23.2031 11.7565L22.7969 10.8427L15.5969 14.0427L16.0031 14.9565ZM15.3 14.6996V23.8996H16.3V14.6996H15.3ZM12.3107 13.4542L19.9107 9.95415L19.4924 9.04585L11.8924 12.5458L12.3107 13.4542Z"
        fill="black"
      />
    </svg>
  );
}
